import api from "./api";
import {
  ListSystemPagesResponse,
  SaveSystemPagePayload,
  SystemPage,
} from "../types/SystemPage";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("authToken");

  if (!token) {
    throw new Error("Token não encontrado");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

export async function findAllPages(
  currentPage: number,
  perPage: number,
  filters?: {
    module_id?: number;
    module?: string;
  },
): Promise<ListSystemPagesResponse> {
  const response = await api.get<ListSystemPagesResponse>("/pages", {
    params: {
      page: currentPage,
      per_page: perPage,
      ...filters,
    },
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function findPage(pageId: string | number): Promise<SystemPage> {
  const response = await api.get<SystemPage>(`/pages/${pageId}`, {
    headers: getAuthHeaders(),
  });

  return response.data;
}

export async function createPage(payload: SaveSystemPagePayload): Promise<void> {
  await api.post("/pages", payload, {
    headers: getAuthHeaders(),
  });
}

export async function updatePage(
  pageId: string | number,
  payload: SaveSystemPagePayload,
): Promise<void> {
  await api.put(`/pages/${pageId}`, payload, {
    headers: getAuthHeaders(),
  });
}

export async function deletePage(pageId: string | number): Promise<void> {
  await api.delete(`/pages/${pageId}`, {
    headers: getAuthHeaders(),
  });
}
